/* eslint-disable */
import dayjs from "dayjs";
import Interweave from "interweave";
import React, { useState, useEffect, useMemo } from "react";

import { useNavigate } from "react-router-dom";
import { Box, Button, Grid, Typography } from "@material-ui/core";
import { useSelector, useDispatch } from "react-redux";

import KPTable from "../../../../components/KPTComponents/KPTable";
import HosoAbout from "../components/about";
import HosoProfile from "../components/profile";
import PreviewModal from "../../../../components/CustomComponents/PreviewModal";
import ThanhTichInsert from "../../ThanhTichInsert/ThanhTichInsert";
import MultiPreviewModal from "../../../../components/CustomComponents/MultiPreviewModal/MultiPreviewModal";
import DuyetThanhTichModalV2 from "../../../../components/CustomComponents/DuyetThanhTichModalV2";

import { columnRender } from "../../../../utils/columnRender";
import { hoSoColumnMap } from "../../../../utils/qcv/hoSo.column_table";
import {
  APP_SCENE,
  ACHIEVEMENT_TYPE,
  KEYS,
  ROLE,
} from "../../../../constants/enums";
import { kvcAchievementFields, capitalizeFirstLetter } from "../../../../utils";
import {
  MONOGRAPHS_CONSTANTS,
  REPORTS_CONSTANTS,
  ROUTER,
} from "../../../../constants";
import {
  KVC2026_STATE_REWARD_OPTIONS,
  KVC2026_COMMITMENT_FIELDS,
  composeTypicalWorkHtml,
} from "../../../../constants/kvc2026.config";
import { fileRender } from "../../../../utils/photoRender";
import { isDomesticQcvCode } from "../../../../utils/qcvScoreOptions";
import {
  formActions,
  profileActions,
  scoreInformationActions,
} from "../../../../actions";

export default function HoSoViewAdmin(props) {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [values, setValues] = useState(null);
  const [dialog, setDialog] = useState(null);
  const [previewFile, setPreviewFile] = useState(null);
  const [duyetThanhTich, setDuyetThanhTich] = useState(null);

  const arrayPath = window.location.href.split("/");
  const urlId = parseInt(arrayPath.slice(arrayPath.length - 1));

  const role = useSelector((state) => state.userReducer.user?.role);
  const focusForm = useSelector((state) => state.formReducer.focusForm);
  const profileId = useSelector((state) => state.profileReducer.profile?.id);
  const openSeasonId = useSelector((state) => state.seasonReducer.openSeasonId);
  const applicationList = useSelector(
    (state) => state.formReducer.applicationList
  );
  const scoreInformationList = useSelector(
    (state) => state.scoreInformationReducer.scoreInformationList
  );

  const handleAccept = (row = duyetThanhTich) => {};

  useEffect(() => {
    if (applicationList.length === 0) dispatch(profileActions.getProfileList());
  }, []);

  useEffect(() => {
    if (openSeasonId)
      dispatch(
        scoreInformationActions.getScoreInformationBySeasonId(openSeasonId)
      );
  }, [openSeasonId]);

  useEffect(() => {
    if (applicationList) {
      const applicationDetail = applicationList.find((e) => e.id === urlId);
      dispatch(formActions.setFocusForm(applicationDetail));
    }
  }, [applicationList]);

  const applicationDetail = useMemo(() => {
    const detail = { ...focusForm };
    if (focusForm) {
      Object.keys(ACHIEVEMENT_TYPE).forEach((key) => {
        const _key = "form" + capitalizeFirstLetter(ACHIEVEMENT_TYPE[key]);
        detail[ACHIEVEMENT_TYPE[key]] = detail[_key]
          .map((e) => ({
            ...e[ACHIEVEMENT_TYPE[key]],
            note: e.note,
            score: e.score,
            accepted: e.accepted,

            [`${_key}Id`]: e.id,
            thanhTichAccepted: e.accepted,
          }))
          .sort((a, b) => a.id - b.id);
      });

      detail.formResearchProject = detail.formResearchProject.map((e) => ({
        ...e,
        // TODO: Sửa backend cái json này
        start_at: dayjs(e.start_at).format("DD/MM/YYYY"),
        finish_at: dayjs(e.finish_at).format("DD/MM/YYYY"),
      }));

      // Backend "report" không lưu filterType -> domestic = "không phải quốc tế".
      // Ưu tiên nhận diện code MỚI qua qcv_score_infos (thử cả 2 mục vì KVC lồng
      // sâu hơn: research/report chỉ có 1 mục quốc tế, monograph có cả 2 chiều);
      // bản ghi cũ/chưa migrate thì fallback theo mảng type cũ (q1-q4/s1-s8).
      const isDomKvc = (value, ...mucPrefixes) => {
        for (const muc of mucPrefixes) {
          const r = isDomesticQcvCode(scoreInformationList, muc, value, "");
          if (r !== null) return r;
        }
        return null;
      };

      detail[ACHIEVEMENT_TYPE.SCIENTIFIC_REPORT + KEYS.DOMESTIC] = detail[
        ACHIEVEMENT_TYPE.SCIENTIFIC_REPORT
      ].filter((e) => {
        const isDom = isDomKvc(e.type, "1.2");
        if (isDom !== null) return isDom;
        return (
          e.filterType === KEYS.DOMESTIC ||
          (!e.filterType &&
            !REPORTS_CONSTANTS.TYPE_OPTIONS.INTERNATIONAL.find(
              (option) => e.type === option.value
            ))
        );
      });
      detail[ACHIEVEMENT_TYPE.SCIENTIFIC_REPORT + KEYS.INTERNATIONAL] = detail[
        ACHIEVEMENT_TYPE.SCIENTIFIC_REPORT
      ].filter((e) => {
        const isDom = isDomKvc(e.type, "1.2");
        if (isDom !== null) return !isDom;
        return (
          e.filterType === KEYS.INTERNATIONAL ||
          (!e.filterType &&
            REPORTS_CONSTANTS.TYPE_OPTIONS.INTERNATIONAL.find(
              (option) => e.type === option.value
            ))
        );
      });
      detail[ACHIEVEMENT_TYPE.MONOGRAPH + KEYS.DOMESTIC] = detail[
        ACHIEVEMENT_TYPE.MONOGRAPH
      ].filter((e) => {
        const isDom = isDomKvc(e.type, "2.3", "1.3");
        if (isDom !== null) return isDom;
        return MONOGRAPHS_CONSTANTS.TYPE_OPTIONS.DOMESTIC.find(
          (option) => e.type === option.value
        );
      });
      detail[ACHIEVEMENT_TYPE.MONOGRAPH + KEYS.INTERNATIONAL] = detail[
        ACHIEVEMENT_TYPE.MONOGRAPH
      ].filter((e) => {
        const isDom = isDomKvc(e.type, "2.3", "1.3");
        if (isDom !== null) return !isDom;
        return MONOGRAPHS_CONSTANTS.TYPE_OPTIONS.INTERNATIONAL.find(
          (option) => e.type === option.value
        );
      });
      detail[ACHIEVEMENT_TYPE.RESEARCH_PROJECT] = detail[
        ACHIEVEMENT_TYPE.RESEARCH_PROJECT
      ].map((e) => ({
        ...e,
        start_at: dayjs(e.start_at).format("DD/MM/YYYY"),
        finish_at: dayjs(e.finish_at).format("DD/MM/YYYY"),
      }));
      detail[ACHIEVEMENT_TYPE.SCIENTIFIC_RESEARCH + KEYS.DOMESTIC] = detail[
        ACHIEVEMENT_TYPE.SCIENTIFIC_RESEARCH
      ].filter((e) => e.filterType === KEYS.DOMESTIC);
      detail[ACHIEVEMENT_TYPE.SCIENTIFIC_RESEARCH + KEYS.INTERNATIONAL] =
        detail[ACHIEVEMENT_TYPE.SCIENTIFIC_RESEARCH].filter(
          (e) => e.filterType === KEYS.INTERNATIONAL
        );

      const safeParse = (str, fallback) => {
        try { return JSON.parse(str) ?? fallback; } catch (e) { return fallback; }
      };
      detail.process = safeParse(detail.process, []);
      detail.socialActivity = safeParse(detail.socialActivity, []);
      detail.personalAchievement = safeParse(detail.personalAchievement, []);
      detail.commitment = safeParse(detail.commitment, {});

      // C.1 Khen thưởng: tách cấp Nhà nước & Bộ/ban/ngành/tỉnh.
      const comm = safeParse(detail.communicationActivity, []);
      const commArr = Array.isArray(comm) ? comm : [];
      detail.communicationActivity = commArr;
      detail.stateReward = commArr.filter((r) => (r?.rewardGroup || "state") === "state");
      detail.ministryReward = commArr.filter((r) => r?.rewardGroup === "ministry");

      // A. Công trình tiêu biểu: ưu tiên typicalWorkContent (4 mục), fallback
      // summary (HTML mới hoặc mảng cũ).
      const twContent = safeParse(detail.typicalWorkContent, null);
      if (twContent) {
        detail.typicalWorkHtml = composeTypicalWorkHtml(twContent);
      } else {
        const legacy = safeParse(detail.summary, null);
        if (Array.isArray(legacy)) detail.typicalWorkHtml = legacy.join("<br/>");
        else detail.typicalWorkHtml = typeof detail.summary === "string" ? detail.summary : "";
      }
      detail.summary = [];

      const fileList = safeParse(detail.previewFile, []);
      const fileArr = Array.isArray(fileList) ? fileList : [];
      detail.sumaryFile = fileArr.find((file) => typeof file === "string" && file.includes("sumaryFile"));
      detail.camKetFile = fileArr.find((file) => typeof file === "string" && file.includes("camKetFile"));
      detail.previewFile = fileArr.filter((file) => typeof file === "string" && file.includes("previewFile"));
    }
    return detail;
  }, [focusForm]);

  const actions = useMemo(() => {
    if (props.isSuperAdmin) return ["link", "edit", "score"];
    else if (applicationDetail.profile?.id === profileId)
      return ["link", "detail"];
    else return ["link"];
  }, [applicationDetail, profileId, props.isSuperAdmin]);

  const achievementFields = kvcAchievementFields({
    achievementData: applicationDetail,
    actions,
  });

  useEffect(() => {
    if (applicationDetail && applicationDetail?.profileId) {
      if (
        !props.isSuperAdmin &&
        applicationDetail?.profileId !== profileId &&
        role !== ROLE.COUNCIL &&
        role !== ROLE.COUNCIL_KVC
      ) {
        navigate(ROUTER.PAGE_401);
      }
    }
  }, [props.isSuperAdmin, applicationDetail]);

  return (
    <>
      <Grid container style={{ padding: 32 }}>
        {!props.achievementsOnly && (<>
        <HosoProfile applicationDetail={applicationDetail} />
        <HosoAbout applicationDetail={applicationDetail} />
        {applicationDetail?.previewFile?.length > 0 && (
          <Typography>
            <b>
              05 ảnh ứng viên tham gia các hoạt động học tập, nghiên cứu khoa
              học, hoạt động vì cộng đồng:{" "}
            </b>
            <a
              href="#"
              onClick={() => setPreviewFile(applicationDetail.previewFile)}
            >
              Xem tại đây
            </a>
          </Typography>
        )}

        <Grid item xs={5} style={{ marginTop: 32, marginBottom: 8 }}>
          <Box bgcolor="#c8c7cc" padding={1} fontSize={21}>
            QUÁ TRÌNH HỌC TẬP, CÔNG TÁC
          </Box>
        </Grid>
        <Grid item xs={7} />
        <Grid item xs={12}>
          <KPTable
            nonBorder={false}
            columns={hoSoColumnMap[APP_SCENE].hocTapCongTac()}
            rows={applicationDetail?.process}
          />
        </Grid>

        {/* ===== A. CÔNG TRÌNH TIÊU BIỂU ===== */}
        <Grid item xs={12} style={{ marginTop: 32 }}>
          <Box bgcolor="#c8c7cc" padding={1} fontSize={21}>
            A. CÔNG TRÌNH TIÊU BIỂU
          </Box>
        </Grid>
        <Grid item xs={12} style={{ marginTop: 8 }}>
          <Interweave content={applicationDetail?.typicalWorkHtml || ""} />
          {applicationDetail?.sumaryFile && (
            <Typography style={{ marginTop: 8 }}>
              <b>Bản công trình tiêu biểu (có xác nhận): </b>
              <a
                target="_blank"
                rel="noreferrer"
                href={fileRender(applicationDetail.sumaryFile)}
              >
                Xem tại đây
              </a>
            </Typography>
          )}
        </Grid>

        </>)}

        {/* ===== B. THÀNH TÍCH KHOA HỌC ===== */}
        <Grid item xs={12} style={{ marginTop: 32 }}>
          <Box bgcolor="#c8c7cc" padding={1} fontSize={21}>
            B. THÀNH TÍCH KHOA HỌC
          </Box>
        </Grid>
        {achievementFields.map((achivement) => (
          <Grid item xs={12} key={achivement.index} style={{ marginTop: 8 }}>
            <Typography variant="h6" style={{ margin: "8px 0" }}>
              <b>
                {achivement.index}. {achivement.title}
              </b>
            </Typography>
            {achivement.children?.map((child) => (
              <Box key={child.index} style={{ marginBottom: 8 }}>
                <Box display="flex" margin="8px 0">
                  <Typography variant="subtitle1" align="justify">
                    <b>
                      {child.index}. {child.title}
                    </b>
                  </Typography>
                </Box>
                <KPTable
                  nonBorder={false}
                  rows={child.data}
                  columns={
                    props.isSuperAdmin
                      ? columnRender(
                          child,
                          setDialog,
                          setPreviewFile,
                          setDuyetThanhTich
                        )
                      : columnRender(child, setDialog, setPreviewFile, null)
                  }
                />
              </Box>
            ))}
          </Grid>
        ))}

        {!props.achievementsOnly && (<>
        {/* ===== C. THÀNH TÍCH KHEN THƯỞNG VÀ HOẠT ĐỘNG CỘNG ĐỒNG ===== */}
        <Grid item xs={12} style={{ marginTop: 32 }}>
          <Box bgcolor="#c8c7cc" padding={1} fontSize={21}>
            C. THÀNH TÍCH KHEN THƯỞNG VÀ HOẠT ĐỘNG CỘNG ĐỒNG
          </Box>
        </Grid>
        <Grid item xs={12} style={{ marginTop: 8 }}>
          <Typography variant="subtitle1" style={{ margin: "8px 0" }}>
            <b>1. Thành tích khen thưởng</b>
          </Typography>
          <Typography variant="body2" style={{ margin: "4px 0" }}>
            <b>1.1. Được nhận hình thức khen thưởng cấp Nhà nước</b>
          </Typography>
          <KPTable
            nonBorder={false}
            rows={applicationDetail?.stateReward}
            columns={[
              { title: <b>Nội dung khen thưởng</b>, dataIndex: "otherAchievementContent", width: "50%" },
              {
                title: <b>Hình thức</b>,
                dataIndex: "otherAchievementType",
                width: "30%",
                render: (value) =>
                  KVC2026_STATE_REWARD_OPTIONS.find((o) => o.value === value)?.title || "",
              },
              {
                title: <b>Minh chứng</b>,
                dataIndex: "otherAchievementPreviewFile",
                width: "20%",
                render: (value) =>
                  value ? (
                    <Button color="primary" style={{ textTransform: "none" }} onClick={() => setPreviewFile(value)}>
                      Chi tiết
                    </Button>
                  ) : null,
              },
            ]}
          />
          <Typography variant="body2" style={{ margin: "8px 0 4px" }}>
            <b>1.2. Được nhận Bằng khen Bộ, ban, ngành, tỉnh</b>
          </Typography>
          <KPTable
            nonBorder={false}
            rows={applicationDetail?.ministryReward}
            columns={[
              { title: <b>Nội dung khen thưởng</b>, dataIndex: "ministryRewardContent", width: "80%" },
              {
                title: <b>Minh chứng</b>,
                dataIndex: "ministryRewardPreviewFile",
                width: "20%",
                render: (value) =>
                  value ? (
                    <Button color="primary" style={{ textTransform: "none" }} onClick={() => setPreviewFile(value)}>
                      Chi tiết
                    </Button>
                  ) : null,
              },
            ]}
          />
        </Grid>
        <Grid item xs={12} style={{ marginTop: 16 }}>
          <Typography variant="subtitle1" style={{ margin: "8px 0" }}>
            <b>2. Hoạt động cộng đồng</b>
          </Typography>
          <Typography variant="body2" style={{ margin: "4px 0" }}>
            <b>2.1. Hoạt động chia sẻ tri thức, tập huấn, đào tạo,...</b>
          </Typography>
          <KPTable
            nonBorder={false}
            columns={hoSoColumnMap[APP_SCENE].hoatDongChiaSeTriThuc((value) =>
              setPreviewFile(value)
            )}
            rows={applicationDetail?.personalAchievement}
          />
          <Typography variant="body2" style={{ margin: "8px 0 4px" }}>
            <b>2.2. Hoạt động tình nguyện vì cộng đồng nói chung</b>
          </Typography>
          <KPTable
            nonBorder={false}
            columns={hoSoColumnMap[APP_SCENE].hoatDongCongDong((value) =>
              setPreviewFile(value)
            )}
            rows={applicationDetail?.socialActivity}
          />
        </Grid>

        {/* ===== D. CAM KẾT CỦA ỨNG VIÊN ===== */}
        <Grid item xs={12} style={{ marginTop: 32 }}>
          <Box bgcolor="#c8c7cc" padding={1} fontSize={21}>
            D. CAM KẾT CỦA ỨNG VIÊN
          </Box>
        </Grid>
        <Grid item xs={12} style={{ marginTop: 8 }}>
          {KVC2026_COMMITMENT_FIELDS.map((f) => (
            <Box key={f.key} style={{ marginBottom: 8 }}>
              <Typography variant="body2">
                <b>{f.label}</b>
              </Typography>
              <Typography variant="body2" style={{ whiteSpace: "pre-line" }}>
                {applicationDetail?.commitment?.[f.key] || ""}
              </Typography>
            </Box>
          ))}
          {applicationDetail?.camKetFile && (
            <Typography style={{ marginTop: 8 }}>
              <b>Bản cam kết của ứng viên: </b>
              <a
                target="_blank"
                rel="noreferrer"
                href={fileRender(applicationDetail.camKetFile)}
              >
                Xem tại đây
              </a>
            </Typography>
          )}
        </Grid>

        {/* ===== E. XÁC NHẬN HỒ SƠ ===== */}
        <Grid item xs={12} style={{ marginTop: 32 }}>
          <Box bgcolor="#c8c7cc" padding={1} fontSize={21}>
            E. XÁC NHẬN HỒ SƠ
          </Box>
        </Grid>
        <Grid item xs={12} style={{ marginTop: 8 }}>
          {applicationDetail?.confirmationFile ? (
            <Typography>
              <b>File xin xác nhận: </b>
              <Button
                color="primary"
                style={{ textTransform: "none", padding: 0, minWidth: "auto" }}
                onClick={() => setPreviewFile(applicationDetail.confirmationFile)}
              >
                Xem
              </Button>
            </Typography>
          ) : (
            <Typography variant="body2">Không có</Typography>
          )}
        </Grid>
        </>)}
      </Grid>

      <ThanhTichInsert dialog={dialog} setDialog={setDialog} />
      <PreviewModal
        open={!!previewFile && typeof previewFile === "string"}
        url={previewFile}
        handleClose={() => setPreviewFile(null)}
      />
      <MultiPreviewModal
        open={!!previewFile && typeof previewFile !== "string"}
        url={previewFile}
        handleClose={() => setPreviewFile(null)}
      />
      <DuyetThanhTichModalV2
        info={duyetThanhTich}
        open={!!duyetThanhTich}
        handleAccept={handleAccept}
        values={values}
        setValues={setValues}
        scoreInformationList={scoreInformationList}
        handleClose={() => setDuyetThanhTich(null)}
      />
    </>
  );
}
